import { verifyAuthentication, refreshToken } from "../../service/AuthService";
import { authStore } from "../../store/AuthStore";
import { dialogStore } from "../../store/DialogStore";
import { fetchAdminAccountByUsername } from "../firebase/Firestore";

export async function vaildateAuthentication(): Promise<boolean> {
    
    try {
        const isValid = await verifyAuthentication();
        if (isValid) {
            if (authStore.user == null) {
                authStore.loadUserState();
            }
            return true;
        }
        const newToken = await refreshToken();
        console.log("✅ 토큰 갱신 성공");
        return true;
    } catch (e) {
        console.error("vaildateAuthentication - Token Validation Failed");

        dialogStore.showDialog({
            title: '알림',
            message: '세션이 만료되었습니다. 로그인 페이지로 이동합니다.',
            onConfirm: () => {
                authStore.logout();
            },
            onClose: () => {
                authStore.logout();
            },
        });
        
        return false;
    }
}